import React, { useEffect, useRef } from 'react';
import './PianoRollCaret.css';

import {
    CaretController,
    CaretScrollCallbackParams
} from "../../utils/ScrollController";

export function PianoRollCaret({
    caretController
}: {
    caretController: CaretController
}) {

    const caretRef = useRef(null);

    useEffect(() => {
        const id = caretController.register((p: CaretScrollCallbackParams) => {
            requestAnimationFrame(() => {
                if (!caretRef || !caretRef.current) return;
                (caretRef.current as HTMLElement).style.left = p.style.left;
            });
        });

        return () => {
            caretController.unregister(id);
        }
    }, []);

    return (<div ref={caretRef} className='piano-roll-caret'>

    </div>);
}
